<template>
  <div id="app" :class="IsAshing ? 'IsAshing' : ''">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import { WebIsAshing } from "@/api"
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      IsAshing: false,
    };
  },
  mounted() {
    let vm = this;
    this.isRouterAlive = false;
    this.$store.dispatch("GetClassiFicareTree").then((res) => {
      this.isRouterAlive = true;
    });

    //是否灰化网站
    WebIsAshing().then(res => {
      vm.IsAshing = res;
    })
  },
  methods: {
    // 通过声明reload方法，控制router-view的显示或隐藏，从而控制页面的再次加载
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style lang="less">
body {
  background-color: #f7f7f7 !important;
}

* {
  margin: 0;
  padding: 0;
}

.swiper-pagination-bullet-active {
  background: #b50003 !important;
}

.ivu-select-item-selected,
.ivu-select-item-selected:hover {
  color: #b50003;
}

.ivu-select-selection {
  border-radius: 0;
  outline: none;

  &:hover {
    border-color: #ddd;
  }
}

.ivu-select-visible .ivu-select-selection {
  border-color: #ddd;

  &:hover {
    border-color: #ddd !important;
  }
}

.ivu-select-selection:hover {
  border-color: #ddd !important;
}

.editordetail {
  padding-top: 22px;
  padding-bottom: 50px;

  p {
    padding-bottom: 20px;
    background-color: transparent !important;
    font-size: 14px !important;
    font-family: "微软雅黑" !important;
    line-height: 28px !important;
    background: none !important;

    span {
      font-size: 14px !important;
      font-family: "微软雅黑" !important;
      background: none !important;
    }
  }

  img {
    max-width: 100%;
    display: block;
    margin: auto;
  }
}

.bannertxt {
  .swiper-wrapper {
    // align-items: flex-end;
  }
}

.isMore {
  margin: 20px 0 30px;
  width: 100%;
  background: #e1e1e1;
  height: 50px;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  line-height: 50px;
  color: #999;
  font-size: 16px;
}

.w-e-text {

  h1,
  h2,
  h3,
  h4,
  h5,
  table,
  pre {
    margin: 15px 0;
    line-height: 2;
    color: #333;
  }

  ul,
  ol {
    margin: 0;
  }

  blockquote {
    display: block;
    border-left: 8px solid #e1d0d0;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }

  code {
    display: inline-block;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }

  pre {
    code {
      display: block;
    }
  }

  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;

    td,
    th {
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      padding: 3px 5px;
      min-height: 30px;
      height: 30px;
    }

    th {
      border-bottom: 2px solid #ccc;
      text-align: center;
      background-color: #f1f1f1;
    }
  }

  &:focus {
    outline: none;
  }

  img,
  video {
    cursor: pointer;
    max-width: 80%;
    display: block;
    margin: auto;
    margin-bottom: 10px;
    // &:hover {
    //   box-shadow: 0 0 5px #333;
    // }
  }

  a,
  a:active {
    color: #333;
  }

  .w-e-todo {
    margin: 0 0 0 20px;

    li {
      list-style: none;
      font-size: 1em;

      span:nth-child(1) {
        position: relative;
        left: -18px;

        input {
          position: absolute;
          margin-right: 3px;
        }

        // 防止其他样式通过属性选择器重置input样式
        input[type="checkbox"] {
          top: 50%;
          margin-top: -6px;
        }
      }
    }
  }

  h1 {
    font-size: 32px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 18.72px;
  }

  h4 {
    font-size: 16px;
  }

  h5 {
    font-size: 13.28px;
  }

  p,
  i {
    font-size: 14px;
    font-family: "微软雅黑";

    line-height: 28px;
    background: none;
    clear: both;
    overflow: hidden;
    padding-top: 10px;
    color: #333;
  }

  /*表情菜单样式*/
  .eleImg {
    cursor: pointer;
    display: inline-block;
    font-size: 18px;
    padding: 0 3px;
  }

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  /*分割线样式*/
  hr {
    cursor: pointer;
    display: block;
    height: 0px;
    border: 0;
    border-top: 3px solid #ccc;
    margin: 20px 0;
  }

  iframe {
    max-width: 100% !important;
    display: block;
    margin: auto;
  }

  p {
    text-indent: 2em;
  }
}

@media (max-width: 769px) {
  .w-e-text {
    iframe {
      max-height: 200px !important;
    }
  }
}

.IsAshing {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
}

// #app {
//   filter: grayscale(100%);
//   -webkit-filter: grayscale(100%);
// }
</style>



// WEBPACK FOOTER //
// src/App.vue